import type { ReviewStateArray } from "@/constants";
import clsx from "clsx";
import { useMemo } from "react";
import { Badge } from "@/components/ui/badge";

export function ReviewRequestStatusBadge({
  status,
  className: cn,
}: {
  status: (typeof ReviewStateArray)[number];
  className?: string;
}) {
  const { className, text } = useMemo(() => {
    switch (status) {
      case "queued":
        return {
          className: "bg-blue-200 text-blue-800",
          text: "排队中",
        };
      case "reviewing":
        return {
          className: "bg-green-200 text-blue-800",
          text: "复盘中",
        };
      case "rejected":
        return {
          className: "bg-red-200 text-red-800",
          text: "已被拒绝",
        };
      case "cancelled":
        return {
          className: "bg-gray-200 text-gray-800",
          text: "已取消",
        };
      case "reviewed":
        return {
          className: "bg-gray-800 text-gray-200",
          text: "已复盘",
        };
    }
  }, [status]);

  return (
    <Badge className={clsx(className, cn, "cursor-default")}>
      <span>{text}</span>
    </Badge>
  );
}
